import React, { useContext, useState, useEffect } from 'react';
import { Form, Col, Tabs, Tab, Alert, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import api from "../../../api/index";
import { ModalContext } from '../../../contexts/modal';
import { trackPromise } from 'react-promise-tracker';
import Recaptcha from 'react-recaptcha';
import RichGooglePlacesAutoComplete from "../../../autocomplete/RichGooglePlacesAutoComplete";

const FormAffiliate = ({ onFormSubmit, id, userType }) => {
    const { handleModalClose, onSubmitButtonHide, SubmitButtonShow } = useContext(ModalContext);
    const [tabKey, setTabKey] = useState('message1');
    const [alert, setAlert] = useState(false);
    const [validCaptcha, setValidCaptcha] = useState(false);
    const [CaptchaClicked, setCaptchaClicked] = useState(false);
    const [showPasword, setShowPassword] = useState(false);
    const [showConfirmPasword, setShowConfirmPasword] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');



    const validSchema = Yup.object().shape({
        email: Yup.string().email().required("Required"),
        cellNumber: Yup.string().required("Required").max(11, 'Phone must contain 11 numbers').min(11, 'Phone must contain 11 numbers'),
        city: Yup.string().required("Required"),
        // area: Yup.string().required("Required"),
        password: Yup.string().required("Required").min(8, "Your password must be at least 8 characters long"),
        conPassword: Yup.string().required('required').oneOf([Yup.ref("password"), null], "Passwords must match").min(8, "Confirm password must be at least 8 characters long"),
        reCaptcha: Yup.string().required("Required"),

        // gender: Yup.string().required("Required"),
    });

    const showForm = () => {
        setTabKey("form1")
        SubmitButtonShow()
    }

    var verifyCallback = function (token, formik) {
        formik.setFieldValue('reCaptcha', token)
        setCaptchaClicked(true);
        setValidCaptcha(false)
        console.log("recaptcha-token:", token);
    };

    const handleShowPassword = () => {
        showPasword ? setShowPassword(false) : setShowPassword(true)
    }

    const handleShowConfirmPassword = () => {
        showConfirmPasword ? setShowConfirmPasword(false) : setShowConfirmPasword(true)
    }
    async function onSubmit(values) {
        console.log("va", values)
        try {
            if (CaptchaClicked) {
                await api.post("/auth/signup", {
                    ...values,
                    userType,
                    role: 'affiliate'
                });
                setTabKey("registeration-finish")
                onSubmitButtonHide()
            }
            else {
                setValidCaptcha(true)
            }

        } catch (error) {
            setAlert(true);
            setAlertMessage(error.response.data.message)

        }

    };
    useEffect(() => {
        onSubmitButtonHide()
    }, [])

    return (
        <Tabs
            defaultActiveKey={tabKey}
            transition={false}
            id="noanim-tab-example"
            className="my-tabs"
        >
            <Tab eventKey="form1" title="" active={tabKey === "form1" ? true : false}>
                <Formik
                    onSubmit={(values) => trackPromise(onSubmit(values), 'register')}
                    validationSchema={validSchema}
                    enableReinitialize
                    initialValues={{
                        email: '',
                        cellNumber: '',
                        city: '',
                        // area: '',
                        reCaptcha: "",
                        password: "",
                        conPassword: "",
                    }}>
                    {(formik) => (
                        <Form
                            onSubmit={formik.handleSubmit}
                            id={id}
                        >
                            {
                                alert ?
                                    <Alert variant="danger" className="rounded text-align-center">{alertMessage}</Alert>
                                    : ""
                            }
                            <Form.Row>
                                <Form.Group controlId="email" as={Col} hasValidation>
                                    <Form.Label className="form__label">Email</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="email"
                                        placeholder="Enter email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.email && !formik.errors.email}
                                        isInvalid={formik.touched.email && formik.errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="cellNumber" as={Col} hasValidation>
                                    <Form.Label className="form__label">Mobile</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="cellNumber"
                                        placeholder="03xxxxxxxxx"
                                        value={formik.values.cellNumber}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.cellNumber && !formik.errors.cellNumber}
                                        isInvalid={formik.touched.cellNumber && formik.errors.cellNumber}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.cellNumber}
                                    </Form.Control.Feedback>
                                </Form.Group>

                            </Form.Row>

                            <Form.Row>
                                <Form.Group controlId="city" as={Col} hasValidation>
                                    <Form.Label className="form__label">City</Form.Label>
                                    {/* <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="city"
                                        placeholder="Enter City"
                                        value={formik.values.city}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.city && !formik.errors.city}
                                        isInvalid={formik.touched.city && formik.errors.city}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.city}
                                    </Form.Control.Feedback> */}
                                    <RichGooglePlacesAutoComplete defaultValue={formik.values.city} placeholder="  City" onLocationSelect={({ description }) => {
                                        formik.setFieldValue('city', description);
                                        // setformValues({ ...formValues, city: description })
                                    }} />
                                </Form.Group>

                                <Form.Group controlId="password" as={Col} hasValidation>
                                    <Form.Label className="form__label">Password</Form.Label>
                                    <div style={{ position: "relative", display: "flex" }}>
                                        <Form.Control
                                            className="p-3 rounded-0 "
                                            // style={{backG}}
                                            type={showPasword ? "text" : "password"}
                                            name="password"
                                            autoComplete="new-password"
                                            style={{ backgroundImage: 'none' }}
                                            placeholder="Please Enter Your Password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isValid={formik.touched.password && !formik.errors.password}
                                            isInvalid={formik.touched.password && formik.errors.password}
                                        />
                                        {

                                            showPasword ?
                                                <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowPassword()
                                                }}></i>
                                                :
                                                <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowPassword()
                                                }} ></i>
                                        }
                                    </div>
                                    <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                        {formik.errors.password}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {/* <Form.Group controlId="area" as={Col} hasValidation>
                                    <Form.Label className="form__label">Area</Form.Label> */}
                                {/* <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="area"
                                        placeholder="Enter Area"
                                        value={formik.values.area}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.area && !formik.errors.area}
                                        isInvalid={formik.touched.area && formik.errors.area}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.area}
                                    </Form.Control.Feedback> */}
                                {/* <RichGooglePlacesAutoComplete defaultValue={formik.values.area} placeholder="  Area" onLocationSelect={({ description }) => {
                                        formik.setFieldValue('area', description);
                                        // setformValues({ ...formValues, city: description })
                                    }} />
                                </Form.Group> */}
                            </Form.Row>
                            <Form.Row>
                                <Form.Group controlId="conPassword" as={Col} hasValidation>
                                    <Form.Label className="form__label">Confirm Password</Form.Label>
                                    <div style={{ position: "relative", display: "flex" }}>
                                        <Form.Control
                                            className="p-3 rounded-0"
                                            type={showConfirmPasword ? "text" : "password"}
                                            name="conPassword"
                                            placeholder="Please Enter Confirm Password"
                                            value={formik.values.conPassword}
                                            style={{ backgroundImage: 'none' }}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isValid={formik.touched.conPassword && !formik.errors.conPassword}
                                            isInvalid={formik.touched.conPassword && formik.errors.conPassword}
                                        />
                                        {

                                            showConfirmPasword ?
                                                <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowConfirmPassword()
                                                }}></i>
                                                :
                                                <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowConfirmPassword()
                                                }} ></i>
                                        }
                                    </div>

                                    <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                        {formik.errors.conPassword}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="conPassword" as={Col} hasValidation>

                                    <Recaptcha
                                        sitekey="6LdGOiYcAAAAAO8vVyJmcsFWg81-OgtEOV3llG4e"
                                        render="explicit"
                                        // onloadCallback={() => console.log("clicked")}
                                        verifyCallback={(token) => verifyCallback(token, formik)}
                                        value={formik.values.reCaptcha}
                                        // onChange={e => handleFormikFileChange(e, formik)}
                                        name="reCaptcha"

                                    />
                                    {formik.errors.reCaptcha ?
                                        <span style={{ margintop: "0.25rem", fontSize: "80%", color: "#dc3545" }}>Required</span> : ""} <br />
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    )}
                </Formik>
            </Tab>
            <Tab eventKey="message1" title="" active={tabKey === "message1" ? true : false}>
                <div>
                    <span style={{ fontSize: '20px', lineHeight: '1.8' }}>
                        <h4>Earn regular income from a one-time effort</h4>
                        <span>
                            Welcome to our affiliate / Influencer program.We really respect and value your privacy. After sign up, you will get access to your account and your own dashboard.
                        </span>
                    </span>
                </div>
                <Button className="button" style={{ float: "right" }} onClick={showForm} >
                    Next
                </Button>
            </Tab >
            <Tab eventKey="registeration-finish" title="" active={tabKey === "registeration-finish" ? true : false}>
                <div>
                    <span style={{ fontSize: '20px', lineHeight: '1.8' }}>
                        We really respect and value your privacy <br /> <br />
                        <h4>Thank you and welcome to our Affiliate / Influencer program.</h4>
                        <span>
                            We are a new startup company with innovative ideas which are beneficial for the clients to upscale their businesses. We truly respect our relationship and will provide you promised incentives in time. One of our colleague will be in contact with further details.
                        </span> <br /> <br />

                        Once again welcome on board.<br /> <br />
                        Subka Faida
                    </span>
                </div>
            </Tab >
        </Tabs >
    )
}

export default FormAffiliate;